module.exports = __webpack_public_path__ + "static/media/johnAvatarBg.75b00a54.png";